import "./PlatesComponent.scss";
import {useDispatch, useSelector} from "react-redux";
import ENV from "../../../constants/ENV";
import React, {useEffect} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import useSystemLockUpdateLabOs from "../../../shared/hooks/useSystemLockUpdateLabOs";

interface PlatesComponentProps {

}

const PlatesComponent = (props: PlatesComponentProps) => {
    useSystemLockUpdateLabOs();
    const dispatch = useDispatch();

    const token = useSelector((state: any) => state.account.token);

    let LabPlatesUrl = `${ENV.LAB_OS_URL}?module=plates_list&token=${token}`;

    useEffect(() => {
        dispatch(setCurrentNavParams("Lab OS", "LabOS"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const {currentUser} = useSelector((state: any) => state.account);
    const {selectedLab} = useSelector((state: any) => state.selectedLab);
    if(currentUser?.roleObj?.code !== "labAdmin" && selectedLab){
        LabPlatesUrl = `${ENV.LAB_OS_URL}?module=plates_list&token=${token}&labId=${selectedLab}`
    }

    return (
        <div className={'storage-component  lab-os-component'}>
            <iframe
                src={LabPlatesUrl}
                // src={`http://192.168.0.7:3005?token=${token}`}
                className={'labOs-iframe '}
                width="100%"
                height="100%"
                title={'LabOs'}
                loading={'eager'}
            />
        </div>
    );

};

export default PlatesComponent;
